import { render, staticRenderFns } from "./AppFileLink.vue?vue&type=template&id=9dd96022&"
import script from "./AppFileLink.vue?vue&type=script&lang=js&"
export * from "./AppFileLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports